import { render } from "./ZZRY.vue?vue&type=template&id=0eac1e87"
import script from "./ZZRY.vue?vue&type=script&lang=js"
export * from "./ZZRY.vue?vue&type=script&lang=js"

import "./ZZRY.vue?vue&type=style&index=0&id=0eac1e87&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__